// Stretchy.selectors.base = Stretchy.selectors.base + ', input[type="anyother"]';
Stretchy.selectors.filter = ".stretchy, .stretchy *";